export enum ServiceNowPage {
  CommitmentRewards = 'commitment_rewards_start',
  NameChangeRequest = 'name_change_request',
  CustomMixQuoting = 'custom_mix_quote',
}

export type ServiceNowLaunchSlug = 'cr-agreement' | 'name-change' | 'custom-mix';

export interface ServiceNowLaunchPage {
  page: ServiceNowPage;
  title: string;
}

export const SERVICE_NOW_LAUNCH_BASE_PATH = 'servicenow';

export const SERVICE_NOW_LAUNCH_PAGES: Record<ServiceNowLaunchSlug, ServiceNowLaunchPage> = {
  'cr-agreement': { page: ServiceNowPage.CommitmentRewards, title: 'CR Agreement Tool' },
  'name-change': { page: ServiceNowPage.NameChangeRequest, title: 'Name Change Request' },
  'custom-mix': { page: ServiceNowPage.CustomMixQuoting, title: 'Custom Mix Quoting Form' },
};

export function serviceNowLaunchUrl(slug: ServiceNowLaunchSlug, custID: number): string {
  return `/${SERVICE_NOW_LAUNCH_BASE_PATH}/${slug}/${custID}`;
}

export function findServiceNowLaunchPage(slug: string | null): ServiceNowLaunchPage | undefined {
  return slug !== null && isServiceNowLaunchSlug(slug) ? SERVICE_NOW_LAUNCH_PAGES[slug] : undefined;
}

function isServiceNowLaunchSlug(slug: string): slug is ServiceNowLaunchSlug {
  return Object.hasOwn(SERVICE_NOW_LAUNCH_PAGES, slug);
}
